import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';



import axios from 'axios';
import { AgregarCuenta } from './modalAgregarCuenta';
import useTableFijo from '../useTableFijo';


function TablaTrasladoOrigen(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sec', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Prog', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Spro', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Proy', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Act', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Par', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Gen', textAlign: 'center' },
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Esp', textAlign: 'center' },
        { id: '9', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sub', textAlign: 'center' },
        { id: '10', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Ord', textAlign: 'center' },
        { id: '11', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
        { id: '12', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Disponible', textAlign: 'center' },
        { id: '13', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Total', textAlign: 'center' },
        { id: '14', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [btni, setBtni] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [records, setRecords] = useState([]);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [idval, setIdval] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const txtMonto = useRef([]);
    const txtMontoTotal = useRef();
    const txtBtnIncluir = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {

            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        } if (ope === 3) {

        }

    }

    useEffect(() => {

        if (props.datarecords.length > 0) {

            if (props.operacion === 3) {

                var data = [...props.datarecords];
                var datos = [];

                for (let i = 0; i < data.length; i++) {

                    datos.push({
                        idcuenta: data[i].idcuenta,
                        auxiliar: data[i].auxiliar,
                        monto: data[i].monto,
                        idcat: data[i].idcategoriaprogramatica,
                        idpuc: data[i].idpuc,

                    });

                }
            }
            props.data(datos);

        }

    }, [props.datarecords]);

    useEffect(() => {

        if (props.validatabla.length > 0) {

            setIdval(props.validatabla);

        }

    }, [props.validatabla]);

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        let data = [...records];


        for (let i = 0; i < datos.length; i++) {

            data.push({
                uno: datos[i].uno,
                dos: datos[i].dos,
                tres: datos[i].tres,
                cuatro: datos[i].cuatro,
                cinco: datos[i].cinco,
                seis: datos[i].seis,
                siete: datos[i].siete,
                ocho: datos[i].ocho,
                nueve: datos[i].nueve,
                auxiliar: datos[i].auxiliar,
                descripcion: datos[i].descripcion,
                disponible: datos[i].disponible,
                monto: datos[i].monto,
                idcuenta: datos[i].idcuenta,
                idcat: datos[i].idcat,
                idpuc: datos[i].idpuc,
                descripcionaux: datos[i].descripcionaux,

            });

        }

        let total = 0.00;
        let ids = [];
        for (let e = 0; e < data.length; e++) {
            total = parseFloat(total) + parseFloat(data[e].monto);
            ids.push({
                id: data[e].idcuenta
            })
        }
        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setIdval(ids);
        setRecords(data);
        props.data(data);
    }

    useEffect(() => {

        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    uno: data[i].cuenta.substring(0, 2),
                    dos: data[i].cuenta.substring(2, 4),
                    tres: data[i].cuenta.substring(4, 6),
                    cuatro: data[i].cuenta.substring(6, 8),
                    cinco: data[i].cuenta.substring(8, 10),
                    seis: data[i].cuenta.substring(10, 13),
                    siete: data[i].cuenta.substring(13, 15),
                    ocho: data[i].cuenta.substring(15, 17),
                    nueve: data[i].cuenta.substring(17, 19),
                    auxiliar: data[i].auxiliar,
                    descripcat: data[i].descripcat,
                    descrippuc: data[i].descrippuc,
                    monto: data[i].monto,
                    disponible: data[i].disponibilidad,
                    descripcionaux: data[i].descripcionaux,
                    idcat: data[i].idcategoriaprogramatica,
                    idpuc: data[i].idpuc,
                    idcuenta: data[i].idcuenta,

                });

            }

            let total = 0.00;

            for (let e = 0; e < data.length; e++) {
                total = parseFloat(total) + parseFloat(data[e].monto);
            }

            txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords(datos);
        }

    }, [props.datarecords]);

    const eliminarPresupuesto = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];
        var blanquea = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.idcuenta !== datos[i].idcuenta) {
                elementos.push(datos[i]);
            }

        }

        let total = 0.00;

        for (let e = 0; e < elementos.length; e++) {
            total = parseFloat(total) + parseFloat(elementos[e].monto);
        }

        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);

        blanquea.push({

            uno: "",
            dos: "",
            tres: "",
            cuatro: "",
            descripcion: "",
            monto: "0.00"

        });

        setRecords(elementos);
        //props.data(blanquea);
        props.data(elementos);
    }

    const validarMonto = (index) => (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '1,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '1,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }
            if (event.target.id === 'monto') {

                let data = [...records];

                var monto = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));

                data[index].monto = monto;

                let total = 0.00;
                let dispon = 0.00;

                for (let i = 0; i < data.length; i++) {
                    total = parseFloat(total) + parseFloat(data[i].monto);
                    dispon = parseFloat(data[i].disponible);
                }
                if (monto > dispon) {
                    setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'El Monto no debe ser Mayor a la Disponibilidad', icono: 'error' });
                    data[index].monto = parseFloat('0.00');
                    total = 0.00;
                    for (let i = 0; i < data.length; i++) {
                        total = parseFloat(total) + parseFloat(data[i].monto);
                        dispon = parseFloat(data[i].disponible);
                    }
                    txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    props.data(data);
                } else {
                    txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    setRecords(data);
                    props.data(data);
                }



            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    useEffect(() => {

        if (props.validaboton === 1) {
            setBtni(false);
        } else {
            setBtni(true);
        }

    }, [props.validaboton]);

    return (
        <div>

            <AgregarCuenta
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                valida={idval}
                dataorigen={props.dataorigen}
                datadestino={props.datadestino}
                destino={false}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />

            <Dimmer active={activate} inverted>

            </Dimmer>



            <div className="row col-md-12 mx-auto m-0">

                <div className="col-md-11 m-0 px-0 mb-1">
                    <TblContainer container={{ height: 130, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px' }}>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.uno}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.dos}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.tres} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.cuatro} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '20px' }}>{item.cinco} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.seis} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.siete} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.ocho} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.nueve} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '20px' }}>{item.auxiliar} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '150px' }}>{item.descripcionaux !== '' ? item.descripcionaux : item.descripcion} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '70px' }}>{formatMoneda(item.disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '70px' }}>
                                            <input type="text" onKeyUp={validarMonto(index)} disabled={props.operacion === 4 || props.operacion === 5 || props.operacion === 2 ? true : false} onBlur={validarMonto(index)} className="form-control form-control-sm bg-transparent text-right border-0" id="monto" defaultValue={formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)} ref={el => txtMonto.current[index] = el} />
                                        </td>
                                        <td className='align-middle' style={{ textAlign: "center", width: '60px' }}>
                                            <button onClick={eliminarPresupuesto(item)} style={{ visibility: (props.operacion === 4 || props.operacion === 2 || props.operacion === 3 || props.operacion === 5) && 'collapse' }} disabled={props.operacion === 4 || props.operacion === 5 || props.operacion === 2 ? true : false} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>
                <div className='col-md-1 m-auto mb-1'>

                    <div className="col-md-12">
                        <button onClick={opciones(1, '')} ref={txtBtnIncluir} disabled={props.operacion === 4 || props.operacion === 2 || props.operacion === 3 || props.operacion === 5 ? true : btni} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"><small> INCLUIR</small></i> </button>
                    </div>

                </div>
                <div className='col-md-11 m-0 px-0  mb-1'>
                    <div className='col-sm-3 ml-auto px-0'>
                        <div className="input-group input-group-sm m-0 w-100">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Total a Trasladar:</label>
                            <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoTotal} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );

}

export default TablaTrasladoOrigen;
